var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "_form" },
    [
      _c(
        "b-row",
        { staticClass: "m-0" },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center px-2 p-lg-5 mt-2",
              attrs: { lg: "12" }
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "px-xl-2 mx-auto",
                  attrs: { sm: "12", md: "8", lg: "6" }
                },
                [
                  _c(
                    "b-card",
                    [
                      _c(
                        "b-card-title",
                        {
                          staticClass: "mb-1 font-weight-bold text-center",
                          attrs: { "title-tag": "h2" }
                        },
                        [_vm._v(" Olá, bem-vindo(a)! ")]
                      ),
                      !_vm.generalOrientation
                        ? _c(
                            "b-card-text",
                            { staticClass: "mb-2 text-center" },
                            [
                              _vm._v(" Formulário de Relato"),
                              _c("br"),
                              _c("br")
                            ]
                          )
                        : _vm._e(),
                      _vm.generalOrientation
                        ? _c("b-card-text", {
                            directives: [
                              {
                                name: "html-safe",
                                rawName: "v-html-safe",
                                value: _vm.generalOrientation,
                                expression: "generalOrientation"
                              }
                            ],
                            staticClass: "mb-2"
                          })
                        : _vm._e(),
                      _c(
                        "validation-observer",
                        { ref: "requestForm" },
                        [
                          _c(
                            "b-form",
                            {
                              staticClass: "mb-1 mt-2",
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.send($event)
                                },
                                keydown: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field01"
                                    ),
                                    "label-for": "isIdentify"
                                  }
                                },
                                [
                                  _c(
                                    "b-form-radio-group",
                                    {
                                      attrs: {
                                        id: "isIdentify",
                                        name: "isIdentify"
                                      },
                                      on: { change: _vm.updateIsIdentify },
                                      model: {
                                        value: _vm.form_data.isIdentify,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form_data,
                                            "isIdentify",
                                            $$v
                                          )
                                        },
                                        expression: "form_data.isIdentify"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-form-radio",
                                        { attrs: { value: false } },
                                        [_vm._v(_vm._s(_vm.$t("no")))]
                                      ),
                                      _c(
                                        "b-form-radio",
                                        { attrs: { value: true } },
                                        [_vm._v(_vm._s(_vm.$t("yes")))]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm.form_data.isIdentify
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "reporting_channel.form.field01_01"
                                        ),
                                        "label-for": "field01_01"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("field01_01"),
                                          "custom-messages": {
                                            required: _vm.$t(
                                              "messages.field_requerid"
                                            )
                                          },
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    staticClass: "required",
                                                    attrs: {
                                                      id: "field01_01",
                                                      name: "personName",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null
                                                    },
                                                    on: {
                                                      keypress: function(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          $event.keyCode !== 13
                                                        ) {
                                                          return null
                                                        }
                                                        $event.preventDefault()
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form_data.person
                                                          .name,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form_data.person,
                                                          "name",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form_data.person.name"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3368712133
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form_data.isIdentify
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "reporting_channel.form.field01_02"
                                        ),
                                        "label-for": "field01_02"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("field01_02"),
                                          "custom-messages": {
                                            required: _vm.$t(
                                              "messages.field_requerid"
                                            ),
                                            cpf: _vm.$t(
                                              "messages.field_invalid"
                                            )
                                          },
                                          rules: "required|cpf"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    directives: [
                                                      {
                                                        name: "mask",
                                                        rawName: "v-mask",
                                                        value: "###.###.###-##",
                                                        expression:
                                                          "'###.###.###-##'"
                                                      }
                                                    ],
                                                    staticClass: "required",
                                                    attrs: {
                                                      id: "field01_02",
                                                      name: "personDocument",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null
                                                    },
                                                    on: {
                                                      keypress: function(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          $event.keyCode !== 13
                                                        ) {
                                                          return null
                                                        }
                                                        $event.preventDefault()
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form_data.person
                                                          .document,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form_data.person,
                                                          "document",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form_data.person.document"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1932873567
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form_data.isIdentify
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "reporting_channel.form.field01_03"
                                        ),
                                        "label-for": "field01_03"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("field01_03"),
                                          "custom-messages": {
                                            required: _vm.$t(
                                              "messages.field_requerid"
                                            ),
                                            email: _vm.$t(
                                              "messages.field_invalid"
                                            )
                                          },
                                          rules: "required|email"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    staticClass: "required",
                                                    attrs: {
                                                      id: "field01_03",
                                                      name: "field01_03",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null
                                                    },
                                                    on: {
                                                      keypress: function(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          $event.keyCode !== 13
                                                        ) {
                                                          return null
                                                        }
                                                        $event.preventDefault()
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form_data.person
                                                          .email,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form_data.person,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form_data.person.email"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1683548481
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.form_data.isIdentify
                                ? _c(
                                    "b-form-group",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "reporting_channel.form.field01_04"
                                        ),
                                        "custom-messages": {
                                          required: _vm.$t(
                                            "messages.field_requerid"
                                          )
                                        },
                                        "label-for": "field01_04"
                                      }
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t("field01_04"),
                                          "custom-messages": {
                                            required: _vm.$t(
                                              "messages.field_requerid"
                                            )
                                          },
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                return [
                                                  _c("b-form-input", {
                                                    directives: [
                                                      {
                                                        name: "mask",
                                                        rawName: "v-mask",
                                                        value: [
                                                          "(##)####-####",
                                                          "(##)#####-####"
                                                        ],
                                                        expression:
                                                          "['(##)####-####', '(##)#####-####']"
                                                      }
                                                    ],
                                                    staticClass: "required",
                                                    attrs: {
                                                      id: "field01_04",
                                                      name: "field01_04",
                                                      state:
                                                        errors.length > 0
                                                          ? false
                                                          : null
                                                    },
                                                    on: {
                                                      keypress: function(
                                                        $event
                                                      ) {
                                                        if (
                                                          !$event.type.indexOf(
                                                            "key"
                                                          ) &&
                                                          $event.keyCode !== 13
                                                        ) {
                                                          return null
                                                        }
                                                        $event.preventDefault()
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form_data.person
                                                          .phone,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form_data.person,
                                                          "phone",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form_data.person.phone"
                                                    }
                                                  }),
                                                  _c(
                                                    "small",
                                                    {
                                                      staticClass: "text-danger"
                                                    },
                                                    [_vm._v(_vm._s(errors[0]))]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3852091016
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("reporting_channel.important")
                                  }
                                },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-line"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "reporting_channel.report_channel_exclusive",
                                                [_vm.legalEntiyName]
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field02_",
                                      [[_vm.legalEntiyName]]
                                    ),
                                    "label-for": "field02"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-radio-group", {
                                              attrs: {
                                                id: "field02",
                                                options:
                                                  _vm.customerRelationshipList,
                                                "value-field": "id",
                                                "text-field": "name",
                                                name: "field02",
                                                stacked: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.customerRelationshipId,
                                                callback: function($$v) {
                                                  _vm.customerRelationshipId = $$v
                                                },
                                                expression:
                                                  "customerRelationshipId"
                                              }
                                            }),
                                            _vm.enableCustomerRelationshipOther
                                              ? _c("b-form-input", {
                                                  staticClass: "required mt-1",
                                                  attrs: {
                                                    id:
                                                      "customerRelationshipOther",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name:
                                                      "customerRelationshipOther"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form_data
                                                        .customerRelationshipOther,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form_data,
                                                        "customerRelationshipOther",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form_data.customerRelationshipOther"
                                                  }
                                                })
                                              : _vm._e(),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field03"
                                    ),
                                    "label-for": "typeReporting"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("v-select", {
                                              ref: "select-typeReporting",
                                              staticClass: "required-select",
                                              attrs: {
                                                options: _vm.typeReportingList,
                                                label: "name"
                                              },
                                              model: {
                                                value:
                                                  _vm.form_data.typeReporting,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_data,
                                                    "typeReporting",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form_data.typeReporting"
                                              }
                                            }),
                                            _vm.enableTypeReportingOther
                                              ? _c("b-form-input", {
                                                  staticClass: "required mt-1",
                                                  attrs: {
                                                    id: "typeReportingOther",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name: "typeReportingOther"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form_data
                                                        .typeReportingOther,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form_data,
                                                        "typeReportingOther",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form_data.typeReportingOther"
                                                  }
                                                })
                                              : _vm._e(),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field04"
                                    ),
                                    "label-for": "unity"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                ref: "select-legal-entity",
                                                staticClass: "required-select",
                                                attrs: {
                                                  options: _vm.listLegal,
                                                  label: "name"
                                                },
                                                model: {
                                                  value: _vm.legalEntity,
                                                  callback: function($$v) {
                                                    _vm.legalEntity = $$v
                                                  },
                                                  expression: "legalEntity"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "no-options"
                                                    },
                                                    slot: "no-options"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("msg_none"))
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field05"
                                    ),
                                    "label-for": "area"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "area",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null
                                              },
                                              on: {
                                                keypress: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    $event.keyCode !== 13
                                                  ) {
                                                    return null
                                                  }
                                                  $event.preventDefault()
                                                }
                                              },
                                              model: {
                                                value: _vm.area,
                                                callback: function($$v) {
                                                  _vm.area = $$v
                                                },
                                                expression: "area"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field06"
                                    ),
                                    "label-for": "knowFact"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "v-select",
                                              {
                                                ref: "select-knowFact",
                                                staticClass: "required-select",
                                                attrs: {
                                                  options: _vm.knowFactList,
                                                  label: "name"
                                                },
                                                model: {
                                                  value: _vm.form_data.knowFact,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form_data,
                                                      "knowFact",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form_data.knowFact"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      slot: "no-options"
                                                    },
                                                    slot: "no-options"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("msg_none"))
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm.enableKnowFactOther
                                              ? _c("b-form-input", {
                                                  staticClass: "required mt-1",
                                                  attrs: {
                                                    id:
                                                      "customerRelationshipOther",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                    name: "knowFactOther"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form_data
                                                        .knowFactOther,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form_data,
                                                        "knowFactOther",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form_data.knowFactOther"
                                                  }
                                                })
                                              : _vm._e(),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field07"
                                    ),
                                    "label-for": "field07"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-radio-group", {
                                              attrs: {
                                                id: "field07",
                                                options: _vm.statusOfReportList,
                                                "value-field": "id",
                                                "text-field": "name",
                                                name: "field07",
                                                stacked: ""
                                              },
                                              model: {
                                                value: _vm.statusOfReportId,
                                                callback: function($$v) {
                                                  _vm.statusOfReportId = $$v
                                                },
                                                expression: "statusOfReportId"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field08"
                                    ),
                                    "label-for": "whatReport"
                                  }
                                },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "reporting_channel.form.field08_01"
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-line"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "reporting_channel.form.field08_02"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("b-form-textarea", {
                                    attrs: {
                                      id: "whatReport",
                                      state:
                                        _vm.form_data.whatReport.length >= 20,
                                      placeholder: _vm.$t(
                                        "form_min_caracter_",
                                        [20]
                                      ),
                                      rows: "4"
                                    },
                                    model: {
                                      value: _vm.form_data.whatReport,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form_data,
                                          "whatReport",
                                          $$v
                                        )
                                      },
                                      expression: "form_data.whatReport"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field09"
                                    ),
                                    "label-for": "keepsHappening"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "keepsHappening",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null
                                              },
                                              on: {
                                                keypress: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    $event.keyCode !== 13
                                                  ) {
                                                    return null
                                                  }
                                                  $event.preventDefault()
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form_data.keepsHappening,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_data,
                                                    "keepsHappening",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form_data.keepsHappening"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field10"
                                    ),
                                    "label-for": "whenAndWho"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "whenAndWho",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null
                                              },
                                              on: {
                                                keypress: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    $event.keyCode !== 13
                                                  ) {
                                                    return null
                                                  }
                                                  $event.preventDefault()
                                                }
                                              },
                                              model: {
                                                value: _vm.form_data.whenAndWho,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_data,
                                                    "whenAndWho",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form_data.whenAndWho"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field11"
                                    ),
                                    "label-for": "otherPeople"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: { id: "otherPeople" },
                                    on: {
                                      keypress: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          $event.keyCode !== 13
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                      }
                                    },
                                    model: {
                                      value: _vm.form_data.otherPeople,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form_data,
                                          "otherPeople",
                                          $$v
                                        )
                                      },
                                      expression: "form_data.otherPeople"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field12"
                                    ),
                                    "label-for": "whatReport"
                                  }
                                },
                                [
                                  _c("small", { staticClass: "text-muted" }, [
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-line"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "reporting_channel.form.field12_01"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          "white-space": "pre-line"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "reporting_channel.form.field12_02"
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]),
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-textarea", {
                                              attrs: {
                                                id: "thereEvidence",
                                                state:
                                                  _vm.form_data.thereEvidence
                                                    .length >= 20,
                                                placeholder: _vm.$t(
                                                  "form_min_caracter_",
                                                  [20]
                                                ),
                                                rows: "4"
                                              },
                                              model: {
                                                value:
                                                  _vm.form_data.thereEvidence,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_data,
                                                    "thereEvidence",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form_data.thereEvidence"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field13"
                                    ),
                                    "label-for": "siteProfile"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: { id: "siteProfile" },
                                    on: {
                                      keypress: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          $event.keyCode !== 13
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                      }
                                    },
                                    model: {
                                      value: _vm.form_data.siteProfile,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form_data,
                                          "siteProfile",
                                          $$v
                                        )
                                      },
                                      expression: "form_data.siteProfile"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field14"
                                    ),
                                    "label-for": "whyReporting"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "whyReporting",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null
                                              },
                                              on: {
                                                keypress: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    $event.keyCode !== 13
                                                  ) {
                                                    return null
                                                  }
                                                  $event.preventDefault()
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form_data.whyReporting,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_data,
                                                    "whyReporting",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form_data.whyReporting"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field15"
                                    ),
                                    "label-for": "howInvestigate"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-input", {
                                              staticClass: "required",
                                              attrs: {
                                                id: "howInvestigate",
                                                state:
                                                  errors.length > 0
                                                    ? false
                                                    : null
                                              },
                                              on: {
                                                keypress: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    $event.keyCode !== 13
                                                  ) {
                                                    return null
                                                  }
                                                  $event.preventDefault()
                                                }
                                              },
                                              model: {
                                                value:
                                                  _vm.form_data.howInvestigate,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form_data,
                                                    "howInvestigate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form_data.howInvestigate"
                                              }
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field16"
                                    ),
                                    "label-for": "employeesAware"
                                  }
                                },
                                [
                                  _c("validation-provider", {
                                    attrs: {
                                      "custom-messages": {
                                        required: _vm.$t(
                                          "messages.field_requerid"
                                        )
                                      },
                                      rules: "required"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          return [
                                            _c(
                                              "b-form-radio-group",
                                              {
                                                attrs: {
                                                  id: "employeesAware",
                                                  name: "employeesAware"
                                                },
                                                model: {
                                                  value:
                                                    _vm.form_data
                                                      .employeesAware,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form_data,
                                                      "employeesAware",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form_data.employeesAware"
                                                }
                                              },
                                              [
                                                _c(
                                                  "b-form-radio",
                                                  { attrs: { value: false } },
                                                  [_vm._v(_vm._s(_vm.$t("no")))]
                                                ),
                                                _c(
                                                  "b-form-radio",
                                                  { attrs: { value: true } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("yes"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            )
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "reporting_channel.form.field17"
                                    ),
                                    "label-for": "financialValue"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: { id: "financialValue" },
                                    on: {
                                      keypress: function($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          $event.keyCode !== 13
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                      }
                                    },
                                    model: {
                                      value: _vm.form_data.financialValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form_data,
                                          "financialValue",
                                          $$v
                                        )
                                      },
                                      expression: "form_data.financialValue"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vx-row pt-2 justify-content-center"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "vx-col" },
                                    [
                                      _c(
                                        "vue-dropzone",
                                        {
                                          ref: "fileUploadZone",
                                          attrs: {
                                            id: "upload",
                                            "use-font-awesome": true,
                                            options: _vm.dropzoneOptions,
                                            "use-custom-dropzone-options": true,
                                            useCustomSlot: true
                                          },
                                          on: {
                                            "vdropzone-success":
                                              _vm.successSendFormWithFile,
                                            "vdropzone-sending":
                                              _vm.sendFormWithFile,
                                            "vdropzone-error":
                                              _vm.errorSendFormFile,
                                            "vdropzone-file-added": [
                                              _vm.added,
                                              _vm.fileAdded
                                            ],
                                            "vdropzone-queue-complete":
                                              _vm.complete
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "dropzone-custom-content"
                                            },
                                            [
                                              _vm._v(
                                                " Arraste e solte para enviar um arquivo "
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "separator" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "separator-span"
                                                    },
                                                    [_vm._v(" ou ")]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "btn waves-effect outline-primary",
                                                  attrs: {
                                                    type: "button",
                                                    variant: "outline-secondary"
                                                  }
                                                },
                                                [_vm._v("Selecionar")]
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-col w-full" },
                                  [
                                    _vm._v(
                                      " Ao preencher o formulário, você concorda que a SECURAMDATA salve e envie as informações prestadas à empresa/organização contratante de seus serviços, possibilitando que medidas sejam tomadas a partir da análise do conteúdo de suas respostas. Para mais informações sobre a proteção de dados e os direitos do usuário, acesse o "
                                    ),
                                    _c(
                                      "b-link",
                                      {
                                        attrs: {
                                          href:
                                            "https://securamdata.com/portal-de-privacidade",
                                          target: "_brank"
                                        }
                                      },
                                      [_vm._v("Portal de Privacidade")]
                                    ),
                                    _vm._v(". ")
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-col w-full" },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        model: {
                                          value: _vm.aware,
                                          callback: function($$v) {
                                            _vm.aware = $$v
                                          },
                                          expression: "aware"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "Li e concordo com o termo acima"
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "vx-row pt-2" }, [
                                _c(
                                  "div",
                                  { staticClass: "vx-col w-full" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "waves-effect float-right",
                                        attrs: {
                                          disabled: !_vm.validateForm,
                                          type: "submit",
                                          variant: "primary"
                                        }
                                      },
                                      [_vm._v(" Enviar ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "b-card-footer",
                        { staticClass: "text-right" },
                        [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v("Desenvolvido por:")
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-link",
                            {
                              attrs: {
                                href: "https://securamdata.com",
                                target: "_brank"
                              }
                            },
                            [_vm._v("securamdata.com")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }